<script lang="ts" setup>
import { FullscreenOutlined, FullscreenExitOutlined } from '@ant-design/icons-vue';
import { useFullscreen } from '@vueuse/core';

const { isFullscreen, enter, exit, toggle } = useFullscreen();
</script>

<template>
  <!-- <FullscreenExitOutlined class="font-size-20" v-if="isFullscreen" @click="toggle" />
  <FullscreenOutlined class="font-size-20" v-else @click="toggle" /> -->

  <span class="w-30px h-30px" i-antd-fullscreen-outlined cursor-pointer v-if="isFullscreen" @click="toggle" />
  <span class="w-30px h-30px" i-antd-fullscreen-exit-outlined cursor-pointer v-else @click="toggle" />
</template>

<style lang="less" scoped></style>
